import React from 'react';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import s from './AwardsSection.scss';

function AwardsSection({ headline, cards, viewMore }) {
  if (!cards || !cards.length) {
    return null;
  }
  return (
    <div className={s.tabular_list_container}>
      {headline && (
        <Listingheader headingname={headline} overrideClass={s.topicheading} />
      )}
      <div className={s.tabular_box}>
        <div className={`${s.tabular_inner} ${s.table_heading}`}>
          <div className={`${s.text_heading} ${s.first_col}`}>Awards Name</div>
          <div className={`${s.text_heading} ${s.second_col}`}>Year</div>
          <div className={`${s.text_heading} ${s.third_col}`}>Categories</div>
        </div>
        {Array.isArray(cards) && cards.length > 0
          ? cards.map((el, idx) => (
              <div key={idx} className={s.tabular_inner}>
                <div className={`${s.text_heading} ${s.first_col}`}>
                  {el.type}
                </div>
                <div className={`${s.inner} ${s.second_col}`}>
                  {Array.isArray(el.awardType) && el.awardType.length > 0
                    ? el.awardType.map((item, i) => (
                        <div key={i} className={s.text_info}>
                          <a href={item.url} className={s.year}>
                            {item.year}
                          </a>
                        </div>
                      ))
                    : null}
                </div>
                <div className={`${s.inner} ${s.third_col}`}>
                  {Array.isArray(el.awardType) && el.awardType.length > 0
                    ? el.awardType.map((item, i) => (
                        <div key={i} className={s.text_info}>
                          <div className={s.info}>
                            {item.category && (
                              <h4 className={s.text}>{item.category}</h4>
                            )}
                            {item.category && item.title && <i>-</i>}
                            {item.title && (
                              <a href={item.url} className={s.link_text}>
                                {item.title}
                              </a>
                            )}
                          </div>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            ))
          : null}
      </div>
      {typeof viewMore === 'function' && (
        <button className={s.morebtn} onClick={() => viewMore('awards', true)}>
          See All Awards
        </button>
      )}
    </div>
  );
}

export default AwardsSection;
